import { useState, useCallback } from 'react';
import { Message } from '../../../types/chat';

export const useChatState = () => {
    // 基础状态
    const [messages, setMessages] = useState<Message[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalMessages, setTotalMessages] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [pageSize] = useState(10);
    const [isInitialized, setIsInitialized] = useState(false);

    // 建议问题相关状态
    const [suggestedQuestions, setSuggestedQuestions] = useState<any>(null);
    const [isLoadingSuggestions, setIsLoadingSuggestions] = useState(false);

    // 更新分页信息
    const updatePagination = useCallback((total: number) => {
        setTotalMessages(total);
        setHasMore(currentPage * pageSize < total);
    }, [currentPage, pageSize]);

    // 更新当前页
    const updateCurrentPage = useCallback((page: number) => {
        if (page !== currentPage) {
            setCurrentPage(page);
        }
    }, [currentPage]);

    // 标记初始化完成
    const markInitialized = useCallback(() => {
        setIsInitialized(true);
    }, []);

    // 重置初始化状态
    const resetInitialized = useCallback(() => {
        setIsInitialized(false);
    }, []);

    return {
        // 状态
        messages,
        isLoading,
        error,
        currentPage,
        totalMessages,
        hasMore,
        pageSize,
        suggestedQuestions,
        isLoadingSuggestions,
        isInitialized,

        // 状态更新函数
        setMessages,
        setIsLoading,
        setError,
        updateCurrentPage,
        updatePagination,
        setSuggestedQuestions,
        setIsLoadingSuggestions,
        markInitialized,
        resetInitialized,
    };
};